<p>department-type works!</p>
